/** Excel/export label for archived client or archived walk-in charge rows. */
export function reportArchivedStatus(
  clientArchived?: boolean,
  recordArchived?: boolean,
): string {
  return clientArchived || recordArchived ? 'Archived' : 'Active';
}
